'use strict';


const parseHostname = process.env.BROWSER
? function (url) {
    var testLink = document.createElement('a');
    testLink.href = url;
    return testLink.hostname;
  }
: function (url) {
    var urlParser = require('url');
    return urlParser.parse(url).hostname;
};

module.exports = parseHostname;



/** WEBPACK FOOTER **
 ** ./utils/parseHostname.js
 **/